"use client";

import { motion } from "motion/react";
import Image from "next/image";
import { partners } from "../data";
import {
  fadeInVariants,
  slideUpVariants,
  createStaggerContainer,
} from "@/lib/animations";

const partnersContainer = createStaggerContainer(0.1);

export function Partners() {
  return (
    <section className="bg-grey-300 p-5 md:px-6 md:py-8 lg:px-10">
      <div className="xl mx-auto flex max-w-7xl flex-col items-center justify-center gap-5 md:flex-row">
        <motion.h2
          className="tracking-copy text-lg font-medium text-green-1100 lg:text-xl"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInVariants}
        >
          We are trusted by:
        </motion.h2>

        <motion.div
          className="flex flex-wrap items-center gap-5 lg:gap-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={partnersContainer}
        >
          {partners.map((partner) => (
            <motion.div key={partner.id} variants={slideUpVariants}>
              <Image
                src={partner.imageUrl}
                alt={partner.name}
                width={partner.width}
                height={partner.height}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
